// extracted by mini-css-extract-plugin
export default {"MiniCell":"MiniCell_MiniCell__CP8Yi"};